type PropsT = {
  availableGiftTotal: number;
};

export const ShareMoreText: React.FunctionComponent<PropsT> = ({
  availableGiftTotal,
}) => {
  return (
    <>
      You can share <b>{availableGiftTotal} more</b>{' '}
      {availableGiftTotal === 1 ? 'article' : 'articles'} this month.
    </>
  );
};
